import styled from 'styled-components';

import TextField from '@omilia/text-field';
import { colors } from '@omilia/theme';

const STextField = styled(TextField)`
  &&& {
    border-top: none;
    border-radius: 0;
    border-bottom: 1px solid ${colors.COLOR_GREY_500};
    z-index: initial;
    box-shadow: none;
    border-left: none;
    border-right: none;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0px 2.2px 8px;
    height: unset;

    &:hover {
      border-bottom: 1px solid ${colors.COLOR_GREY_800};
    }

    &:focus {
      border-bottom: 1px solid ${colors.COLOR_BLUE_600};

      ::placeholder {
        color: ${colors.COLOR_GREY_500};
      }
    }
  }
`;

export default STextField;
